/*
 * Copyright 2017 The boardgame.io Authors.
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */

import App from './simulator';

const routes = [
  {
    path: '/simulator',
    text: 'Simulator',
    component: App,
  },
];

export default { routes };
